var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 23.5,
    fill: "#B4E3E1",
    stroke: "#E7F6F5",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 33L34 30M34 30L37 33M34 30V36M30.5 18.2908C31.9659 18.8841 33 20.3213 33 22C33 23.6787 31.9659 25.1159 30.5 25.7092M27 30H23C21.1362 30 20.2044 30 19.4693 30.3045C18.4892 30.7105 17.7105 31.4892 17.3045 32.4693C17 33.2044 17 34.1362 17 36M28.5 22C28.5 24.2091 26.7091 26 24.5 26C22.2909 26 20.5 24.2091 20.5 22C20.5 19.7909 22.2909 18 24.5 18C26.7091 18 28.5 19.7909 28.5 22Z",
    stroke: "#0D968F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminViewIcon);
export default __webpack_public_path__ + "static/media/admin-view-icon.b4ce648388c38c0e3dd98f0617b2bb59.svg";
export { ForwardRef as ReactComponent };